import * as angular from "angular";
import {ILocationService, ILogProvider, ILogService, IQProvider, IWindowService} from "angular";
import {includes} from "lodash";
import uiRouter, {StateService, TransitionService} from "@uirouter/angularjs";
import "angular-monash";
import {AuthModule} from "../auth/auth.module";
import {FirebaseModule} from "../firebase/firebase.module";
import {WidgetModule} from "../widget/widget.module";
import {NavigationModule} from "../navigation/navigation.module";
import {ieCacheFix} from "./ie-cache-fix.config";
import {genericHttpErrorHandler} from "./generic-http-handler.config";
import {html5Mode} from "./html5-mode.config";
import {templateCacheBuster} from "./template-cache-buster.config";
import {HttpErrorHandlingInterceptor} from "./http-error-handling-interceptor.service";
import {AuthService} from "../auth/auth.service";
import {ILoadingServiceRootScope} from "../loading/loading.service";

const PRODUCTION_HOSTS = [
    "monash-online-credit-prod.appspot.com",
    "online-credits.monash.edu"
];

const isProduction = (host) => includes(PRODUCTION_HOSTS, host);

const initialise = ($transitions: TransitionService,
                    $rootScope: ILoadingServiceRootScope,
                    $location: ILocationService,
                    authService: AuthService,
                    fileUploadService: any,
                    $log: ILogService,
                    $window: IWindowService,
                    $state: StateService,
                    toaster: any) => {
    $log.debug("app.common - Run");

    $rootScope.$on("http-error", (event, response) => {
        $log.debug("HTTP error intercepted", event, response);

        const message = (response.data && response.data.message) ? response.data.message : JSON.stringify(response.data, null, 4);
        $rootScope.stateLoading = false;

        if (response.status === -1) {
            toaster.pop({
                type: "error",
                title: `Upload was cancelled`
            });
        } else {
            toaster.pop({
                type: "error",
                title: `Failed processing your request. Technical details: [${response.status}] ${message}`
            });
        }

    });

    $rootScope.$on("$stateChangeError", (evt, to, toParams, from, fromParams, error) => {
        if (error.redirectTo) {
            $state.go(error.redirectTo);
        } else {
            $state.go("error", {status: error.status});
        }
    });




    $rootScope["showDebugLinks"] = !isProduction($location.host());

    $transitions.onStart({}, (trans) => {
        $log.debug("transition onStart $rootScope %o", $rootScope);

        $rootScope.stateLoading = true;

        const fromState = trans.from();
        const toState = trans.to();

        $log.debug(`State transitioning from ${fromState.name} to ${toState.name}`);
    });

    $transitions.onFinish({}, () => {
        $rootScope.stateLoading = false;
    });

    fileUploadService.setUploadUrl("/api/template/attachment/");

    $log.debug(fileUploadService);
};

export const ConfigModule = angular
    .module("app.shared.config", [
        "angular-monash",
        uiRouter,
        AuthModule,
        FirebaseModule,
        NavigationModule,
        WidgetModule
    ])

    .service("HttpErrorHandlingInterceptor", HttpErrorHandlingInterceptor)

    .config(($logProvider: ILogProvider, $qProvider: IQProvider) => {
        $logProvider.debugEnabled(true);
        $qProvider.errorOnUnhandledRejections(false);
    })
    .config(ieCacheFix)
    .config(templateCacheBuster)
    .config(html5Mode)
    .config(genericHttpErrorHandler)

    .run(initialise)

    .name;




// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/config/config.module.ts